import React, { useLayoutEffect, useRef, useMemo, useState, memo } from "react";

export type VersusDividerProps = {
    asBlock?: boolean;
    hasScore?: boolean;
    show?: boolean;
    sport?: string;
    selectionsLength?: number;
  };

export const VersusDivider = memo<VersusDividerProps>(
  ({
    hasScore,
    asBlock,
    show = false,
    sport,
    selectionsLength
  }: VersusDividerProps) => {
    if (!show) return null;

    const ref = useRef<HTMLDivElement | null>(null);
    const [hasLogo, setHasLogo] = useState(true);

    let scoreClasses = "cui-w-2";
    if (hasScore) scoreClasses = "cui-w-12";
    if (sport === "tennis" && hasScore) scoreClasses = "cui-w-18";

    let widthClasses = asBlock ? "cui-w-full" : "cui-w-1/2";
    if (selectionsLength === 2) widthClasses = "cui-w-2/3";
    if (selectionsLength === 1) widthClasses = "cui-w-3/4";

    useLayoutEffect(() => {
      if (!ref.current) return;
      if (typeof window !== "undefined") {
        const raf = window?.requestAnimationFrame(() => {
          const parent = ref.current?.closest(".cui__card-body");
          const competitors: HTMLElement[] = parent
            ? Array.from(parent?.querySelectorAll(".cui__competitor_wrapper"))
            : [];
          competitors.length &&
            setHasLogo(
              competitors?.every(
                (competitor) => competitor?.dataset?.haslogo === "true"
              )
            );
          window?.cancelAnimationFrame(raf);
        });
      }
    }, []);
    return (
      <div
        className={`cui-h-[3px] ${widthClasses} ${asBlock ? "cui-py-xs" : "cui-absolute cui-bottom-0"} cui-flex cui-items-center`}
        ref={ref}
      >
        {hasLogo ? <div className="cui-w-11" /> : null}
        <div className="cui-h-2 cui-w-auto cui-mr-2 heading-xs cui-bg-neutrals-transparent cui-text-fg-moderate cui-flex cui-items-center">
          vs
        </div>
        <div className={`cui-h-1px cui-flex-grow cui-bg-fg-minimal`} />
        <div className={scoreClasses} />
      </div>
    );
  }
);
